// extracted by mini-css-extract-plugin
module.exports = {"toggle-theme":"_1JW5g","switch":"_1YQRl","switch-input":"_1YGKu","slider":"_3KCg2","text":"_3QdS6"};